<!-- @veltra/icons generated sha256:0730f96aed9042e8 gen:8 source:src/svg/colorful/image.svg -->
<script setup lang="ts">
defineOptions({ name: 'UImage' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#ffc757"
        d="M12.315 14.504H3.721a2.19 2.19 0 0 1-2.187-2.188V3.722c0-1.208.98-2.187 2.187-2.187h8.594c1.208 0 2.187.98 2.187 2.187v8.594a2.19 2.19 0 0 1-2.187 2.188"
      />
      <path
        fill="#ef9f2b"
        d="M12.034 10.077 10.98 8.249a.625.625 0 0 0-1.083 0l-1 1.732-1.86-3.22a.625.625 0 0 0-1.083 0l-1.915 3.316c-.24.417.06.938.542.938h6.913a.625.625 0 0 0 .541-.938M9.299 6.066a.864.864 0 1 0 1.573-.713.864.864 0 0 0-1.573.713"
      />
      <path
        fill="#fff"
        d="M12.034 9.89 10.98 8.06a.625.625 0 0 0-1.083 0l-1 1.733-1.86-3.221a.625.625 0 0 0-1.083 0L4.038 9.89c-.24.416.06.937.542.937h6.913a.625.625 0 0 0 .541-.938M9.299 5.878a.864.864 0 1 0 1.573-.712.864.864 0 0 0-1.573.712"
      />
    </g>
  </svg>
</template>
